import React from "react";
import styled from "styled-components";
import { StyledCheckBox } from "../form/ui";

const UL = styled.ul`
  flex: 1;

  li {
    padding: 0rem 0 0.25rem 0;

    &.last {
      padding-top: 2rem;
    }
  }
`;

const TagList = props => {
  return (
    <UL>
      {props.items.map((item, index) => (
        <li key={index}>
          <StyledCheckBox
            value={item.value}
            label={item.name}
            name={item.name}
            onChange={props.onChange}
            gray={props.gray}
          />
        </li>
      ))}

      {props.onChangeAll && (
        <li key={"li-last"} className="last">
          <StyledCheckBox
            value={props.allSelected}
            label={props.allName}
            name={props.allName}
            onChange={props.onChangeAll}
          />
        </li>
      )}
    </UL>
  );
};

export default TagList;



// WEBPACK FOOTER //
// ./src/modules/common/components/app/TagList.js